import React from 'react';

import styles from './styles.css';

const ListItem = ({ text }) => (
  <li className={styles.listItem} dangerouslySetInnerHTML={{ __html: text }} />
);

const ListBlock = ({ listItems, headline }) => (
  <div className={styles.container}>
    <div className={styles.grid}>
      {headline && <h4 className={styles.headline}>{headline}</h4>}
      {listItems && (
        <ul className={styles.list}>
          {listItems.map(item => (
            <ListItem key={item} text={item} />
          ))}
        </ul>
      )}
    </div>
  </div>
);

export default ListBlock;



// WEBPACK FOOTER //
// ./src/components/ListBlock/index.js